module.exports = __webpack_public_path__ + "static/media/grid.b8be4e7f.svg";